import MasterSKUIndex from "@/components/flux_oms/master_sku/MasterSKUIndex.vue";
import MasterSKUAdd from "@/components/flux_oms/master_sku/MasterSKUAdd.vue";
import MasterSKUEdit from "@/components/flux_oms/master_sku/MasterSKUEdit.vue";

let routesTarifAccess= [
    {
        path: '',
        meta: {
          title: "Master SKU",
        },
        name: "MasterSKUIndex",
        component: MasterSKUIndex
    },
    {
        path: 'create',
        meta: {
          title: "Master SKU Create",
        },
        name: "MasterSKUAdd",
        component: MasterSKUAdd
    },
     
   
     
    {
        path: 'edit/:id',
        meta: {
          title: "Master SKU Edit",
        },
        name: "MasterSKUEdit",
        component: MasterSKUEdit
    },
    
]

export default routesTarifAccess
  